export enum ACCENTSTRIP_VARIANTS {
  DISCO_PINK = 'DISCO_PINK',
  BLUE = 'BLUE',
  PINK = 'PINK',
  PURPLE = 'PURPLE',
  MOSAIC = 'MOSAIC',
  ALT_ORANGE = 'ALT_ORANGE',
  FOIL_SLICK = 'FOIL_SLICK',
  REVERSE_FOIL_SLICK = 'REVERSE_FOIL_SLICK',
  WHITE = 'WHITE',
  PEPPERMINT_CRISP = 'PEPPERMINT_CRISP',
  PASSION_POP = 'PASSION_POP',
  UNAVAILABLE = 'UNAVAILABLE',
  GREEN = 'GREEN',
  BLACK = 'BLACK'
}

export interface IAccentStrip {
  variant?: ACCENTSTRIP_VARIANTS;
  hasOpacity?: boolean;
  isSmall?: boolean;
  isFlexEnd?: boolean;
  isBottom?: boolean;
  isVertical?: boolean;
  isSolid?: boolean;
}
